module.exports = __webpack_public_path__ + "img/Weapon_82.4a5640ad.png";